import { AlertLineURLDTO } from "src/models/alert-line-url/alert-line-url-dto";
import { AlertLineURLSTO } from "src/models/alert-line-url/alert-line-url-sto";
import { BaseApiService } from "../base";

export class AlertLineURLApiService extends BaseApiService<AlertLineURLDTO, AlertLineURLSTO> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineURLs",
      saveItemsPath: "/SaveAlertLineURLs",
    });
  }

  public async getAlertLineURLLogo(alertLineURLId: string, signal?: AbortSignal): Promise<Blob> {
    return this.getFileContent(
      "GetAlertLineURLLogos",
      {
        ids: [alertLineURLId],
      },
      signal
    );
  }

  public async triggerGenerateDocuments() {
    this.useLoadItemsPath("/GetTriggerDocumentForAlertLines");
    this.loadItems()
      .then(() => {
        this.useLoadItemsPath("/GetTriggerDocumentForAlertLineURLs");
        this.loadItems();
      })
      .then(() => {
        this.useLoadItemsPath("/GetTriggerDocumentForAlertLineReportInvestigationEvents");
        this.loadItems();
      })
      .then(() => {
        this.useLoadItemsPath("/GetTriggerDocumentForAlertLineReportNotes");
        this.loadItems();
      });
  }
}
